module.exports = __webpack_public_path__ + "ce13b060911211c2015edda8c88a9f9e.svg";